<template>
    <el-drawer
        title="编辑班级"
        :visible.sync="show"
        direction="rtl"
        :wrapperClosable="false"

        size="600px"
        :before-close="close">
        <div class="panel" v-loading="submiting" element-loading-text="数据提交，并同步生成排课中...请等待">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="班级名称" v-check="{'必填': !form.name}">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="班级类型" v-check="{'必选': !form.useType}">
                    <el-select v-model="form.useType"  placeholder="班级类型" @change="changeLessonSystems">
                        <el-option label="普通班级" :value="1"></el-option>
                        <el-option label="收费班级" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="授权课程体系">
                    <el-checkbox-group v-model="form.lessonSystemIds" class="fx-col fx-m_start fx-c_start">
                        <el-checkbox v-for="item in lessonSystems" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="选择教师">
                    <el-select v-model="form.teacherId" placeholder="请选择教师">
                        <el-option v-for="item in staffs" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                submiting: false,
                form: {...this.item, lessonSystemIds: this.item.lessonSystemIdArray ? this.item.lessonSystemIdArray : []},
                lessonSystems: [],
                staffs: [],
                needRefreshParent: false,
            }

        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                this.submiting = true;
                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                        this.$ajaxPost("/class/save", {
                            clazz: {...this.form, lessonSystemIds: this.form.lessonSystemIds.join(",")}
                        }, (data) => {
                            this.submiting =false;
                            this.$emit("submit", data.result);
                        } , (data) => {
                            this.submiting = false;
                            this.$showError(data.msg);
                        })
                        return false;
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })
            },
            loadLessonSystems() {
                this.$ajaxPost("/lessonSystem/listLessonSystem", {
                    form: {enable: true,useType:this.form.useType}
                }, (data) => {
                    this.lessonSystems = data.result;
                })
            },
            changeLessonSystems() {
                this.form.lessonSystemIds=[];
                this.loadLessonSystems();
            },
            loadTeachers() {
                this.$ajaxPost("/user/list", {
                    form: {
                        enable: true
                    },
                    isStaff: true
                }, data => {
                    this.staffs = data.result;
                })
            }

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadLessonSystems();
            this.loadTeachers();
        }


    }
</script>
